import { queryOptions, useQuery } from '@tanstack/react-query';

import { applicationsApi } from '../api/applications-api';

import { applicationKeys } from './application-keys';

export function applicationQueryOptions(id: string) {
  return queryOptions({
    queryKey: applicationKeys.detail(id),
    queryFn: () => applicationsApi.get(id),
  });
}

export function useApplication(id: string) {
  return useQuery(applicationQueryOptions(id));
}
